import {EventEmitter} from "events";
import dispatcher from './../dispatcher/dispatcher'

class MainStore extends EventEmitter {
    constructor() {
        super();
        this.state = {
            isLoggedIn: false,
            loginError: false,
            registerResponse: '',
            loginResponse: '',
            forgotPasswordResponse: '',
            setPasswordResponse: '',
            changePasswordResponse: '',
            authSuccessResponse: '',
            verifyEmailResponse: '',
            verifyEmailError: ''
        }
    }

    isLogged() {
        return this.state.isLoggedIn;
    }

    validateEmail(email) {
        // eslint-disable-next-line 
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    setCookie(cname, cvalue, exdays) {
        console.log(`in set cookie with val ${cvalue}`)
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";domain=.triplemars.com;" + expires + ";path=/";
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    handleAcions(action) {
        switch (action.type) {
            case 'REGISTER_SUCCESS': {
                this.state.registerResponse = action.data;
                this.emit('changeRegister');
                break;
            }
            case 'REGISTER_ERROR': {
                this.state.registerError = action.data;
                this.emit('changeRegister');
                break;
            }
            case 'LOGIN_SUCCESS': {
                this.state.loginResponse = action.data;
                console.log(`action data: ${JSON.stringify(action.data)}`)
                console.log(`emitting login success with login response ${JSON.stringify(this.state.loginResponse)}`)
                this.emit('change');
                break;
            }
            case 'LOGIN_ERROR': {
                this.state.loginError = true;
                this.emit('change');
                break;
            }
            case 'FORGOT_PASSWORD_SUCCESS': {
                this.state.forgotPasswordResponse = action.data;
                this.emit('changeForgotPassword');
                break;
            }
            case 'SET_PASSWORD_SUCCESS': {
                this.state.setPasswordResponse = action.data;
                this.emit('change');
                break;
            }
            case 'CHANGE_PASSWORD_SUCCESS': {
                this.state.changePasswordResponse = action.data;
                this.emit('change');
                break;
            }
            case 'AUTH_SUCCESS': {
                this.state.authSuccessResponse = action.data;
                this.emit('change');
                break;
            }
            case 'VERIFY_EMAIL_SUCCESS': {
                this.state.verifyEmailResponse = action.data;
                this.emit('changeVerifyEmail');
                break;
            }
            case 'VERIFY_EMAIL_ERROR': {
                this.state.verifyEmailError = action.data;
                this.emit('changeVerifyEmail');
                break;
            }
            default:
                break;
        }
    }
}

const mainStore = new MainStore();
dispatcher.register(mainStore.handleAcions.bind(mainStore))
export default mainStore;